import { keurEmailadres } from './veldregels'

/*
 * Validatie van het contactformulier in de browser (FR-20).
 *
 * Net als bij het aanvraagformulier: een dienst aan de bezoeker, geen controle.
 * `ContactValidator.cs` is de controle, en de regels en meldingen hier zijn
 * daaraan gelijk. Het e-mailadres deelt zijn regel met het aanvraagformulier —
 * zie `veldregels.ts`.
 */

export interface ContactFormulierWaarden {
  email: string
  bericht: string
}

export type ContactFouten = Partial<
  Record<keyof ContactFormulierWaarden, string>
>

/** De volgorde op het scherm; bepaalt welk veld na een afkeuring de focus krijgt. */
export const contactVeldvolgorde: readonly (keyof ContactFormulierWaarden)[] = [
  'email',
  'bericht',
]

/**
 * Ruim genoeg voor een uitgebreide vraag, klein genoeg om te voorkomen dat iemand
 * de mailbox als opslag gebruikt. Het formulier noemt de grens vooraf, zodat
 * niemand een lang bericht typt om het daarna afgekeurd te zien.
 */
export const maximaleBerichtlengte = 2000

export function valideerContact(
  waarden: ContactFormulierWaarden,
): ContactFouten {
  const fouten: ContactFouten = {}

  const email = keurEmailadres(waarden.email)
  if (email) fouten.email = email

  if (waarden.bericht.trim() === '') {
    fouten.bericht = 'Vul uw bericht in.'
  } else if (waarden.bericht.length > maximaleBerichtlengte) {
    fouten.bericht = `Uw bericht mag hoogstens ${maximaleBerichtlengte} tekens bevatten.`
  }

  return fouten
}
